<pk-broker-modal>
	<ng-template #headerTemplate>
		<h5 class="modal-title">Enterprise Lookup</h5>
	</ng-template>
	<ng-template #bodyTemplate>
		<form [formGroup]="searchForm" *ngIf="searchForm" (submit)="onSearch()">
			<div class="input-group mb-3">
				<input type="text" class="form-control" placeholder="Search" formControlName="criteria" (keyup)="onSearch()" />
				<div class="input-group-append">
					<button type="button" class="btn btn-default" (click)="searchForm.reset(); onSearch()">
						<fa-icon [icon]="['fas', 'times']"></fa-icon>
					</button>
					<button type="button" class="btn btn-default" (click)="onSearch()">
						<fa-icon [icon]="['fas', 'search']"></fa-icon>
					</button>
				</div>
			</div>
		</form>
		<dx-data-grid
			id="gridContainer"
			[dataSource]="enterprisesDataSource"
			[allowColumnResizing]="true"
			[columnAutoWidth]="true"
			[showBorders]="true"
			[remoteOperations]="true"
			[rowAlternationEnabled]="true"
			[hoverStateEnabled]="true"
			(onInitialized)="onDataGridInit($event)">
			<dxo-scrolling [useNative]="true"></dxo-scrolling>
			<dxi-column caption="Name" dataField="name" [allowHeaderFiltering]="false"></dxi-column>
			<dxi-column caption="Created" dataField="createdAt" [allowHeaderFiltering]="false"></dxi-column>
			<dxi-column caption="Actions" cellTemplate="actionsCellTemplate" [allowHeaderFiltering]="false"></dxi-column>
			<dxo-paging [pageSize]="50"></dxo-paging>
			<dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
			<div *dxTemplate="let d of 'actionsCellTemplate'">
				<div class="btn-group" role="group">
					<a class="btn btn-primary" href="javascript:void(0)" (click)="selectEnterprise(d.data)">Select</a>
				</div>
			</div>
		</dx-data-grid>
	</ng-template>
	<ng-template #footerTemplate>
		<button type="button" class="btn btn-secondary" (click)="close()">Close</button>
	</ng-template>
</pk-broker-modal>
